export default {
	home: {
		title: "Személyre szabott digitális programfüzet",
		intro: "A Conflive egy új programfüzet mobilalkalmazás, modern rendezvények számára. Segítségével a látogatók informálásán túl, az előadók is visszajelzést kaphatnak a munkájukról, megoszthatják a témához kapcsolódó anyagokat és valós idejű kérdőíveket közölhetnek. Egy konferencia alapeszköze a programfüzet digitális változata, mivel ez a legkézenfekvőbb felülete a kommunikációnak.",
		features: "A program funkciói",
		references: "Referenciák",
		referencesDesc: "Legutóbbi támogatott rendezvényünk: Startup Safary 2017. Az alkalmazások kipróbálhatóak az alábbi linkeken:",
		team: "Csapatunk",
		contact: "Kapcsolat",
		contactDesc: "További információkért és árajánlatkérésért forduljon hozzánk bizalommal.",
		feats: {
			"1title": "Előadó és előadás lista",
			"1desc": "A program információinak listázása a legfontosabb szolgáltatás. Ezen keresztül a látogatók elérhetik a kapcsolati adatokat és a csatolt fájlokat is.",
			"2title": "Szponzor kategóriák",
			"2desc": "Az adatok közlésén túl, a program kiváló reklámfelület a szponzorok számára. A hozzájárulásuk alapján több szintbe kategorizálhatjuk őket.",
			"3title": "Előadás értékelés",
			"3desc": "Minden előadásra hatos skálán visszajelzést küldhetnek a résztvevők, ezzel segítve a szervezők munkáját a jövőbeli program kialakításában.",
			"4title": "Aktuális előadás jelzése",
			"4desc": "Egy kötetlen rendezvény során elengedhetetlen hogy figyelemmel tudjuk követni az aktuálisan zajló előadásokat. Ezeket rögtön a főképernyőn, percre pontosan kijelzi a felületünk.",
			"5title": "Kapcsolódó kérdések",
			"5desc": "Az előadásokhoz kérdéssorokat is mellékelhetünk, egyszerű választási lehetőségekkel. Ezzel felmérhető az előadás anyagának megértése vagy akár nyereményjátékként is alkalmazható.",
			"6title": "Offline használat",
			"6desc": "A programok a legmodernebb fejlesztőeszközök felhasználásával készülnek, iOS és Android platformon. A felépítésüknek köszönhetően az első betöltés után akár internethozzáférés nélkül is működnek.",
			"7title": "Valós idejű kvízkérdések",
			"7desc": "A résztvevőknek lehetőségük van előadásokhoz tartozó kérdéseket azonnal megválaszolni, amiket prezentálhatunk rögtön például egy projektoron keresztül, így az előadó valós időben láthatja a résztvevők válaszait és reagálhat rá.",
			"8title": "Helyszín térkép",
			"8desc": "Több előadáshelyszín esetén az adatok feltüntetésén kívül, akár egy alaprajzon is jelezhetjük a soron következő előadásokat a résztvevőknek.",
			"9title": "Személyre szabott alkalmazás",
			"9desc": "Minden rendezvény más, emiatt folyamatosan készen állunk új funkciók fejlesztésére. Lépjen velünk kapcsolatba, hogy megbeszéljük az igényeket és együtt készítsünk egy új megoldást."
		}
	}
}


// WEBPACK FOOTER //
// ./src/strings/hu.js